export class SelectionRegion {
    constructor() {
        Object.defineProperty(this, "regionElement", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "closeButton", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isDragging", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "isResizing", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "dragStartX", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 0
        });
        Object.defineProperty(this, "dragStartY", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 0
        });
        Object.defineProperty(this, "startX", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 0
        });
        Object.defineProperty(this, "startY", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 0
        });
        Object.defineProperty(this, "startWidth", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 0
        });
        Object.defineProperty(this, "startHeight", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 0
        });
        Object.defineProperty(this, "resizeDirection", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ''
        });
        Object.defineProperty(this, "onBorderMouseDown", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (e) => {
                e.preventDefault();
                const target = e.target;
                const direction = target.dataset.direction;
                if (!direction)
                    return;
                const rect = this.regionElement.getBoundingClientRect();
                this.startX = rect.left;
                this.startY = rect.top;
                this.startWidth = rect.width;
                this.startHeight = rect.height;
                this.dragStartX = e.clientX;
                this.dragStartY = e.clientY;
                this.resizeDirection = direction;
                if (direction === 'top') {
                    this.isDragging = true;
                }
                else {
                    this.isResizing = true;
                }
            }
        });
        Object.defineProperty(this, "onMouseMove", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (e) => {
                if (!this.isDragging && !this.isResizing)
                    return;
                const dx = e.clientX - this.dragStartX;
                const dy = e.clientY - this.dragStartY;
                let newLeft = this.startX;
                let newTop = this.startY;
                let newWidth = this.startWidth;
                let newHeight = this.startHeight;
                const minSize = 20;
                // Move
                if (this.isDragging) {
                    newLeft = this.startX + dx;
                    newTop = this.startY + dy;
                }
                // Resize
                if (this.isResizing) {
                    if (this.resizeDirection.includes('right')) {
                        newWidth = this.startWidth + dx;
                    }
                    if (this.resizeDirection.includes('left')) {
                        newWidth = this.startWidth - dx;
                        newLeft = this.startX + dx;
                    }
                    if (this.resizeDirection.includes('bottom')) {
                        newHeight = this.startHeight + dy;
                    }
                    if (this.resizeDirection.includes('top')) {
                        newHeight = this.startHeight - dy;
                        newTop = this.startY + dy;
                    }
                    // Constrain minimum size
                    if (newWidth < minSize) {
                        newWidth = minSize;
                        if (this.resizeDirection.includes('left')) {
                            newLeft = this.startX + (this.startWidth - minSize);
                        }
                    }
                    if (newHeight < minSize) {
                        newHeight = minSize;
                        if (this.resizeDirection.includes('top')) {
                            newTop = this.startY + (this.startHeight - minSize);
                        }
                    }
                }
                const newStyle = {
                    left: `${newLeft}px`,
                    top: `${newTop}px`,
                    width: `${newWidth}px`,
                    height: `${newHeight}px`,
                };
                Object.assign(this.regionElement.style, newStyle);
                localStorage.setItem('_select-region', JSON.stringify(newStyle));
            }
        });
        Object.defineProperty(this, "onMouseUp", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                this.isDragging = false;
                this.isResizing = false;
            }
        });
        this.createRegion();
        this.addEventListeners();
    }
    // Toggle region with ALT+S
    static toggle() {
        if (SelectionRegion.instance) {
            SelectionRegion.instance.removeRegion();
            SelectionRegion.instance = null;
        }
        else {
            SelectionRegion.instance = new SelectionRegion();
        }
    }
    getBoundingBox() {
        return this.regionElement.getBoundingClientRect();
    }
    getRegionElement() {
        return this.regionElement;
    }
    static getInstance() {
        return SelectionRegion.instance;
    }
    createRegion() {
        this.regionElement = document.createElement('div');
        Object.assign(this.regionElement.style, {
            position: 'fixed',
            top: '100px',
            left: '100px',
            width: '300px',
            height: '200px',
            border: '2px solid rgba(0, 123, 255, 0.8)',
            margin: '-2px',
            boxSizing: 'border-box',
            pointerEvents: 'none', // allow interaction with content under region
            zIndex: '9999',
            ...JSON.parse(localStorage.getItem('_select-region') || 'null'),
        });
        // Create interactive borders
        const borders = ['top', 'right', 'bottom', 'left', 'top-left', 'top-right', 'bottom-left', 'bottom-right'];
        for (const direction of borders) {
            const border = document.createElement('div');
            border.classList.add('sr-border');
            border.dataset.direction = direction;
            this.styleBorder(border, direction);
            this.regionElement.appendChild(border);
        }
        // Create close button (top-right)
        this.closeButton = document.createElement('div');
        Object.assign(this.closeButton.style, {
            position: 'absolute',
            top: '2px',
            right: '4px',
            width: '16px',
            height: '16px',
            fontSize: '14px',
            color: '#fff',
            background: 'rgba(0,0,0,0.5)',
            textAlign: 'center',
            lineHeight: '16px',
            cursor: 'pointer',
            borderRadius: '2px',
            zIndex: '1',
            pointerEvents: 'auto',
        });
        this.closeButton.innerText = '✕';
        this.closeButton.addEventListener('click', () => SelectionRegion.toggle());
        this.regionElement.appendChild(this.closeButton);
        document.body.appendChild(this.regionElement);
    }
    styleBorder(border, direction) {
        const size = 6;
        const moveBarThickness = 9;
        Object.assign(border.style, {
            position: 'absolute',
            zIndex: '1',
            pointerEvents: 'auto',
        });
        const common = {
            backgroundColor: 'transparent',
            cursor: '',
        };
        switch (direction) {
            case 'top':
                Object.assign(border.style, common, {
                    top: '-4px',
                    left: '0',
                    height: `${moveBarThickness}px`,
                    width: '100%',
                    cursor: 'move',
                });
                break;
            case 'right':
                Object.assign(border.style, common, {
                    top: '0',
                    right: '-4px',
                    width: `${size}px`,
                    height: '100%',
                    cursor: 'ew-resize',
                });
                break;
            case 'bottom':
                Object.assign(border.style, common, {
                    bottom: '-4px',
                    left: '0',
                    height: `${size}px`,
                    width: '100%',
                    cursor: 'ns-resize',
                });
                break;
            case 'left':
                Object.assign(border.style, common, {
                    top: '0',
                    left: '-4px',
                    width: `${size}px`,
                    height: '100%',
                    cursor: 'ew-resize',
                });
                break;
            case 'top-left':
                Object.assign(border.style, common, {
                    top: '-4px',
                    left: '-4px',
                    width: `${size}px`,
                    height: `${size}px`,
                    cursor: 'nw-resize',
                });
                break;
            case 'top-right':
                Object.assign(border.style, common, {
                    top: '-4px',
                    right: '-4px',
                    width: `${size}px`,
                    height: `${size}px`,
                    cursor: 'ne-resize',
                });
                break;
            case 'bottom-left':
                Object.assign(border.style, common, {
                    bottom: '-4px',
                    left: '-4px',
                    width: `${size}px`,
                    height: `${size}px`,
                    cursor: 'sw-resize',
                });
                break;
            case 'bottom-right':
                Object.assign(border.style, common, {
                    bottom: '-4px',
                    right: '-4px',
                    width: `${size}px`,
                    height: `${size}px`,
                    cursor: 'se-resize',
                });
                break;
        }
    }
    addEventListeners() {
        // Handle dragging and resizing
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
        const borders = this.regionElement.querySelectorAll('.sr-border');
        borders.forEach((border) => {
            border.addEventListener('mousedown', this.onBorderMouseDown);
        });
        document.addEventListener('mousemove', this.onMouseMove);
        document.addEventListener('mouseup', this.onMouseUp);
    }
    removeRegion() {
        document.removeEventListener('mousemove', this.onMouseMove);
        document.removeEventListener('mouseup', this.onMouseUp);
        this.regionElement.remove();
    }
}
Object.defineProperty(SelectionRegion, "instance", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: null
});
